import builder from '../builder';
import RotateForward from '../../streamline-icons/light/rotate-forward.svg';

export default builder('IconRotateForwardLight', RotateForward);
